import { render, staticRenderFns } from "./BudgetView.vue?vue&type=template&id=215d7928&scoped=true"
import script from "./BudgetView.vue?vue&type=script&lang=js"
export * from "./BudgetView.vue?vue&type=script&lang=js"
import style0 from "./BudgetView.vue?vue&type=style&index=0&id=215d7928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215d7928",
  null
  
)

export default component.exports